import React from 'react'
import { Job, JobWizardMobile } from 'sprockets_react/job_wizards/registries'
import $ from 'sprockets_react/job_wizards/jquery'

JobWizardMobile.ChooseBudget = {
  onSubmit: function(onStepProgression, onRequest, onRequestCompletion, onStepRetreat) {
    if (Job.Data.backToSubmit === true && Job.Data.budgetInMind === 'no'){
      JobWizardMobile.Emitter.emit('job:wizard:advanceToStep', JobWizardMobile.JobSummary)
    }
    else {
      onStepProgression()
    }
  },

  onLeftNavButtonClick(onStepProgression) {
    $('#job-modal').data('bootstrapValidator').removeField('budget_select')
    JobWizardMobile.Emitter.emit('job:wizard:advanceToStep', JobWizardMobile.ChooseSchedule)
  },

  component: React.createClass({
    componentDidMount: function() {
      $('#job-modal').bootstrapValidator({ /* */ })
      this.validator = $('#job-modal').data('bootstrapValidator')

      $('#budget-selection').radioButtonGroup({activeRowClass: 'active'})

      this.componentDoesValidate()
    },

    budgetInMindChanged: function(e) {
      let val = $(e.currentTarget).data('value')
      Job.Actions.updateBudgetInMind(val)

      this.validator.updateStatus($("[name='budget_select']"), "VALID")
    },

    handleBudgetClick: function(e) {
      this.budgetInMindChanged(e)

      $('#budget-amount').addClass('hidden')

      this.autoProgress()
    },

    autoProgress: function() {
      if (Job.Data.backToSubmit === true && Job.Data.budgetInMind === 'no'){
        JobWizardMobile.Emitter.emit('job:wizard:advanceToStep', JobWizardMobile.JobSummary)
      }
      else {
        this.props.onStepProgression()
      }
    },

    componentDoesValidate: function() {
      this.validator.addField('budget_select',
        {
          validators: {
              notEmpty: {
                message: 'Please choose if you have a budget in mind'
              }
            }
        }
      )
    },

    render: function() {
      let radioButtonVisible = "col-xs-2 col-sm-2 circle"
      let radioButtonHidden = `${radioButtonVisible} hidden`

      return (
        <div className="form-group">
          <h3 className="mb15 mt10">Do you have a budget in mind?</h3>
          <ul className="nav nav-tabs nav-justified ss-tabs" role="tablist" id="budget">
            <li role="presentation">
              <a href="#budget-yes" name="budget_select" role="tab" data-toggle="tab" data-value="yes" className="yes" onClick={this.handleBudgetClick}>Yes</a>
            </li>
            <li>
              <a href="#budget-no" name="budget_select" role="tab" data-toggle="tab" data-value="no" className="no" id="budget-no-button" onClick={this.handleBudgetClick}>No</a>
            </li>
          </ul>
        </div>
      )
    }
  })
}
